import type { ImpressumDto } from '../../models/restaurant-api.model';

export interface ImpressumRow {
  label: string;
  value: string;
  href?: string;
}

export interface ImpressumSection {
  title: string;
  rows: readonly ImpressumRow[];
}

const OWNER_SECTION_TITLE = 'A Honlap tulajdonosa és üzemeltetője:';

export function toImpressumOwnerSection(dto: ImpressumDto): ImpressumSection {
  const rows: ImpressumRow[] = [
    { label: 'Vállalkozás megnevezése', value: dto.companyName },
    { label: 'Székhely', value: dto.registeredOffice },
    { label: 'Levelezési cím', value: dto.mailingAddress },
    { label: 'E-mail', value: dto.email, href: `mailto:${dto.email}` },
    { label: 'Adószám', value: dto.taxNumber },
    { label: 'Nyilvántartási szám', value: dto.registrationNumber },
    { label: 'EU Adószám', value: dto.euTaxNumber },
    { label: 'Kamara', value: dto.chamber },
    { label: 'Képviselő', value: dto.representative },
    { label: 'Weboldal', value: dto.websiteUrl, href: dto.websiteUrl },
  ].filter((row) => row.value != null && row.value !== '');

  return {
    title: OWNER_SECTION_TITLE,
    rows,
  };
}

export const impressumHosting: ImpressumSection = {
  title: 'Tárhelyszolgáltató adatai:',
  rows: [
    { label: 'Cégnév', value: 'Rackforest Zrt.' },
    { label: 'Székhely', value: '1132 Budapest, Victor Hugo utca 11. 5. em. B05001. ajtó' },
    {
      label: 'Levelezési cím',
      value: '1132 Budapest, Victor Hugo utca 11. 5. em. B05001. ajtó',
    },
    { label: 'Cégjegyzékszám', value: '08-09-016359' },
    { label: 'Adószám', value: '32056842-2-41' },
    {
      label: 'Weboldal',
      value: 'https://rackforest.com',
      href: 'https://rackforest.com',
    },
    { label: 'E-mail cím', value: 'info@rackforest.com', href: 'mailto:info@rackforest.com' },
  ],
};
